'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('login', {
    url: '/login',
    template: require('./login/login.pug'),
    controller: 'LoginController',
    controllerAs: 'vm'
  })
    .state('logout', {
      url: '/logout?referrer',
      referrer: 'main',
      template: '',
      controller($state, Auth) {
        'ngInject';

        // var referrer = $state.params.referrer || $state.current.referrer || 'login';
        var referrer = 'login';
        Auth.logout();
        $state.go(referrer);
      }
    })
    .state('signup', {
      url: '/signup',
      template: require('./signup/signup.pug'),
      controller: 'SignupController',
      controllerAs: 'vm'
    })
    .state('main.settings', {
      url: '/settings',
      template: require('./settings/settings.pug'),
      controller: 'SettingsController',
      controllerAs: 'vm',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/account.routes.js